export const CREDITOS_FISCALES_COD_RET_PREFIX: string = '2181';
